interface GetHasMetaProps {
	available: boolean
	withArrow: boolean
	isDelayed?: boolean
	showLastUnits?: boolean
}
export function getHasMeta({
	available,
	withArrow,
	isDelayed,
	showLastUnits,
}: GetHasMetaProps): boolean {
	return Boolean(!available || showLastUnits || withArrow || isDelayed)
}
